import React, { useEffect, useState } from "react";

import axios from '../../api/axios';

import {
    Container,
    Header,
    LogoContainer,
    BotaoContainer,
    ListContainer,
    ListHeader,
    ListContent,
    ListPagination,
    AiFillDeleteIcon
} from './styles';

import { useAuth } from "../../hooks/useAuth";

import { IClientProps } from "../../interfaces";
import { IsseusPage } from "../../interfaces";

import toast from 'react-hot-toast';

import ManageClient from "../../components/Dialogs/ManageClientUsers";
import UpdateClient from "../../components/Dialogs/UpdateClient";
import NewClient from "../../components/Dialogs/NewClient";
import NewFeed from "../../components/Dialogs/NewFeed";
import Pagination from "../../components/Pagination";

const AdminPage: React.FC = () => {

    const { user } = useAuth();

    const [rerenderAux, setRerenderAux] = useState<boolean>(false);
    const [clientsDataPage, setClientsDataPage] = useState<IClientProps[]>([]);

    const [pageNumber, setPageNumber] = useState<number>(0);
    const [pagePagination, setPagePagination] = useState<IsseusPage>({
        first: true,
        last: true,
        number: 0,
        totalPages: 0
    });

    useEffect(() => {
        getData();
    }, [rerenderAux, pageNumber]);

    async function getData() {
        await axios.get('/clients/pagination', {
            params: {
                size: 15,
                page: pageNumber
            }
        }).then(response => {
            const r = response.data.content.map((item: { id: any; nome: any; dominio: any; webhook: any; jiraMainIssue: any; jiraSupportIssue: any; idList: any; }) => {
                return {
                    id: item.id,
                    nome: item.nome,
                    dominio: item.dominio,
                    webhook: item.webhook,
                    jiraMain: item.jiraMainIssue,
                    jiraSupport: item.jiraSupportIssue,
                    idList: item.idList
                }
            })
            setClientsDataPage(r);

            let last: boolean;
            let first: boolean;

            if (Number(response.data.number) == 0) {
                first = true;
            } else {
                first = false;
            }

            if (Number(response.data.number) == (Number(response.data.totalPages) - 1)) {
                last = true;
            } else {
                last = false;
            }
            setPagePagination({
                first: first,
                last: last,
                number: pageNumber,
                totalPages: response.data.totalPages
            });
        })
            .catch(e => {
                console.log(e);
            })
    }

    async function handleAddClient(cliente: IClientProps) {
        let clientData = {
            "nome": cliente.nome,
            "dominio": cliente.webhook,
            "webhook": cliente.webhook,
            "idList": parseInt(cliente.idList),
            "jiraMainIssue": cliente.jiraMain,
            "jiraSupportIssue": cliente.jiraSupport
        }

        await axios.post('/clients', clientData)
            .then(response =>
                toast.success("Cliente cadastrado!")
            )
            .catch(e =>
                toast.error("Não foi possível cadastrar o cliente!" + e)
            )

        setRerenderAux(!rerenderAux);
    }

    function handleUpdateClient(cliente: IClientProps) {
        let clientData = {
            "nome": cliente.nome,
            "dominio": cliente.dominio,
            "webhook": cliente.webhook,
            "idList": parseInt(cliente.idList),
            "jiraMainIssue": cliente.jiraMain,
            "jiraSupportIssue": cliente.jiraSupport
        }
        axios.put(`/clients/${cliente.id}`, clientData)
            .then(response =>
                toast.success("Cliente cadastrado!")
            )
            .catch(e =>
                toast.error("Não foi possível cadastrar o cliente!" + e)
            )
    }

    function handleDeleteButon(cliente: IClientProps) {
        if (window.confirm('Deletar o item?')) {
            axios.delete(`/clients/${cliente.id}`)
                .then(response => {
                    confirm('Usuário ' + cliente.nome + ' deletado com sucesso');
                    setRerenderAux(!rerenderAux);
                })
                .catch(e => {
                    alert('Não foi possível deletar o usuário: ' + cliente.nome + '\nMensagem: ' + e)
                })
        }
    }

    function handlePageChange(newPageNumber: number) {
        setPageNumber(newPageNumber);
    }

    async function handleAddFeed(content: string) {
        let feedData = {
            "content": content,
            "userBitrix": {
                "id": Number(user.codUser)
            }
        }
        axios.post('/feeds', feedData)
            .then()
            .catch(e =>
                console.log(e)
            )
    }

    return (
        <Container>
            <Header>
                <LogoContainer>
                    <h1>Admin Page</h1>
                </LogoContainer>
                <BotaoContainer>
                    {/* <Botao onClick={toggleFeedAddModal} title="Adicionar Feed">
                        <IconContext.Provider value={{ color: 'black', size: '25px' }}>
                            <IoMdAddCircleOutline />
                        </IconContext.Provider>
                        <h2>Feed</h2>
                    </Botao>
                    <AddFeedModal
                        userId={user.codUser}
                        hideModal={toggleFeedAddModal}
                        isModalVisible={isShownFeedAddModal}
                    /> */}
                    <NewFeed
                        onFeedCreated={handleAddFeed}
                    />
                    <NewClient
                        onClientCreated={handleAddClient}
                    />
                </BotaoContainer>
            </Header>
            <ListContainer>
                <ListHeader>
                    <h1>Listagem de clientes</h1>
                </ListHeader>
                <ListContent>
                    {
                        clientsDataPage.map((item: IClientProps) => (
                            <li
                                key={item.id}
                            >
                                <div className="li-text-box">
                                    <h2>{item.id}</h2>
                                </div>
                                <div className="li-text-box">
                                    <h3>{item.nome}</h3>
                                </div>
                                <div className="li-text-box">
                                    <h2>{item.dominio}</h2>
                                </div>
                                <div
                                    title="Gerenciar usuários"
                                    className="li-button-container">
                                    <ManageClient
                                        id={item.id}
                                        client={item}
                                    />
                                </div>
                                <div
                                    title="Atualizar cliente"
                                    className="li-button-container">

                                    <UpdateClient
                                        client={item}
                                        onClientUpdated={handleUpdateClient}
                                    />
                                </div>
                                <div className="li-button-container">
                                    <button
                                        title="Deletar cliente"
                                        onClick={() => handleDeleteButon(item)}
                                    >
                                        <AiFillDeleteIcon />
                                    </button>
                                </div>
                            </li>
                        ))
                    }
                </ListContent>
            </ListContainer>
            <ListPagination>
                <Pagination onChange={handlePageChange} page={pagePagination} />
            </ListPagination>
        </Container>
    )
}

export default AdminPage;